module.exports = __webpack_public_path__ + "img/IMG_8948.b110d521.jpg";